import { Todo } from '../types/Todo';

export const exportTodosToJSON = (todos: Todo[]): void => {
  try {
    const dataStr = JSON.stringify(todos, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `todos-${new Date().toISOString().split('T')[0]}.json`;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error exporting todos:', error);
    throw new Error('Failed to export todos. Please try again.');
  }
};

export const importTodosFromJSON = (file: File): Promise<Todo[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      try {
        const content = event.target?.result as string;
        const todos = JSON.parse(content) as Todo[];
        
        // Validate the imported data
        if (!Array.isArray(todos)) {
          throw new Error('Invalid file format. Expected an array of todos.');
        }
        
        // Validate each todo object
        const validatedTodos = todos.map((todo, index) => {
          if (!todo.id || !todo.title || typeof todo.completed !== 'boolean') {
            throw new Error(`Invalid todo at index ${index}. Missing required fields.`);
          }
          
          return {
            id: todo.id,
            title: todo.title,
            description: todo.description || '',
            completed: todo.completed,
            priority: todo.priority || 'medium',
            category: todo.category || 'General',
            dueDate: todo.dueDate || '',
            createdAt: todo.createdAt || new Date().toISOString(),
            updatedAt: todo.updatedAt || new Date().toISOString()
          };
        });
        
        resolve(validatedTodos);
      } catch (error) {
        console.error('Error parsing JSON file:', error);
        reject(new Error('Invalid JSON file. Please check the file format.'));
      }
    };
    
    reader.onerror = () => {
      reject(new Error('Failed to read file. Please try again.'));
    };
    
    reader.readAsText(file);
  });
};

export const saveTodosToLocalFile = (todos: Todo[]): void => {
  try {
    const dataStr = JSON.stringify(todos, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `todos-backup-${new Date().toISOString().replace(/[:.]/g, '-')}.json`;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error saving todos:', error);
    throw new Error('Failed to save todos. Please try again.');
  }
};
